import React from 'react';
import { getAttendanceColor } from '../../../utils/calendarUtils';
import './Calendar.css';

const CalendarLegend = () => {
  const statuses = [
    { label: 'Present', value: 'Present' },
    { label: 'Absent', value: 'Absent' },
    { label: 'Leave', value: 'Leave' },
    { label: 'Half-day', value: 'Half-day' },
    { label: 'Weekly Off', value: 'WeeklyOff' },
    { label: 'Holiday', value: 'Holiday' },
    { label: 'Festival', value: 'Festival', isRainbow: true },
    { label: 'Miss Punch', value: 'Miss-Punch' }
  ];

  return (
    <div className="calendar-legend">
      <span className="legend-title">Legend:</span>
      {statuses.map(status => (
        <div key={status.value} className="legend-item">
          <span 
            className={`legend-color-box ${status.isRainbow ? 'legend-rainbow-box' : ''}`}
            style={status.isRainbow ? {} : { backgroundColor: getAttendanceColor(status.value) }}
          />
          <span className="legend-label">{status.isRainbow ? '🌈 Festival' : status.label}</span>
        </div>
      ))}
    </div>
  );
};

export default CalendarLegend;
